import React from "react";
import { Autocomplete, FilterBar, SearchBar } from "@sscs/ui";
import { ClassificationFilter } from "../../../common";
const Filter = ({ filter, tags, onFilterChange, }) => {
    return (React.createElement(FilterBar, { filters: [
            {
                id: "search-regex",
                control: (React.createElement(SearchBar, { id: "networking-search-regex", fullWidth: false, value: filter.searchRegex, label: "Type regex pattern to search for strings", onChange: (value) => onFilterChange({ ...filter, searchRegex: value }), slotProps: { htmlInput: { maxLength: 256 } } })),
            },
            {
                id: "classification",
                width: "300px",
                control: (React.createElement(ClassificationFilter, { classification: filter.classification, onChange: (value) => {
                        onFilterChange({
                            ...filter,
                            classification: value,
                        });
                    } })),
            },
            {
                id: "tags",
                width: "300px",
                control: (React.createElement(Autocomplete, { id: "networking-filter-tag", label: "Filter by tag", isClearAlwaysVisible: filter.tag !== null, value: filter.tag, options: tags, onChange: (_event, value) => {
                        onFilterChange({ ...filter, tag: value });
                    } })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map